import { TableCell, IconButton } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

export default function ActionsCell({ onEdit, onDelete }) {
  return (
    <TableCell align="right">
      <IconButton size="small" onClick={onEdit}>
        <EditIcon />
      </IconButton>
      <IconButton size="small" color="error" onClick={onDelete}>
        <DeleteIcon />
      </IconButton>
    </TableCell>
  );
}